module.exports = __webpack_public_path__ + "logo-BHP.png?42f4a01ed588076fa9b1aef1ce42d3dc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/logo-BHP.png
// module id = 74
// module chunks = 0